import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { StatusBeketPurchaseTypes, StatusPurchase } from 'shared/constants'
import useCountdownTimer from 'shared/hooks/use-countdown-timer'
import MbonusIcon from 'shared/icons/mbonus-mini-gradient.svg'
import { copyText } from 'shared/lib/copyText.ts'
import { priceShow } from 'shared/lib/priceShow.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { message } from 'shared/ui/message'
import { OrderDetailItem } from 'shared/ui/order-detail-item'
import { Paper } from 'shared/ui/paper'
import { StatusBought } from 'shared/ui/status-bought'

import { OrderDetailTime } from './components/order-detail-timer'
import s from './styles.module.scss'

interface OrderDetail {
  destination: string
  carrier: string
  orderNum: string
  totalPrice: string
  status: StatusBeketPurchaseTypes
  expiredDate: string
  bonus: string | undefined
}

interface Props {
  orderInfo: OrderDetail | null
}

export const MyOrderDetail = ({ orderInfo }: Props) => {
  if (!orderInfo) return null

  const { t } = useTranslation()

  const onCopyOrderId = () => {
    copyText(orderInfo.orderNum)
    message.copy(t('copied_to_clipboard'))
  }

  if (!orderInfo) {
    return
  }

  const timeLeft =
    orderInfo?.status === StatusPurchase.BOOKED.key &&
    useCountdownTimer(orderInfo.expiredDate)

  return (
    <Paper padding={[16]}>
      <div className={s.container}>
        <div className={s.header}>
          <p className={clsx(s.title, 'semi-bold-17')}>
            {t('beket.order_detail')}
          </p>

          <StatusBought status={orderInfo.status} />
        </div>

        <div className={s.info}>
          {timeLeft && !!timeLeft?.total && (
            <OrderDetailItem
              title={t('beket.time_left')}
              slot={<OrderDetailTime expiredDate={orderInfo.expiredDate} />}
            />
          )}

          <OrderDetailItem
            title={t('flight')}
            text={orderInfo.destination}
          />

          <OrderDetailItem
            title={t('beket.carrier')}
            text={orderInfo.carrier}
          />

          <div className={s.copyFlex}>
            <OrderDetailItem
              title={t('order_number')}
              text={orderInfo.orderNum}
            />
            <div onClick={onCopyOrderId}>
              <AppIcon
                id={AllIcons.COPY_PROMO}
                className={s.icon}
              />
            </div>
          </div>

          <div className={s.copyFlex}>
            <OrderDetailItem
              title={t('price')}
              text={t('price_som', { price: priceShow(orderInfo.totalPrice) })}
            />

            {orderInfo.bonus && (
              <div onClick={onCopyOrderId}>
                <OrderDetailItem
                  title={t('mbonus')}
                  slot={
                    <p className={clsx(s.mbonus, 'medium-14')}>
                      {priceShow(orderInfo.bonus)}
                      <img
                        src={MbonusIcon}
                        className={s.iconMbonus}
                      />
                    </p>
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Paper>
  )
}
